module.exports = __webpack_public_path__ + "img/fossil2Img1.7a209b9f.jpg";